import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {EbmsVeeyaaConfig} from '../../../../app-config';
import {NavContentComponent} from './nav-content/nav-content.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  public windowWidth: number;
  public nextConfig: any;
  @Output() onNavMobCollapse = new EventEmitter();
  @ViewChild('navContent', {static: false}) navContent: NavContentComponent;

  constructor() {
    this.nextConfig = EbmsVeeyaaConfig.config;
    this.windowWidth = window.innerWidth;
  }

  ngOnInit() { }

  navMobCollapse() {
    if (this.windowWidth < 992) {
      this.onNavMobCollapse.emit();
    }
  }

  toggleMobileMenu() {
    if (this.navContent) {
      this.navContent.toggleMobileMenu();
    }
  }
}
